export default __webpack_public_path__ + "static/media/1.d26a8276.svg";